import React from 'react';
import { BoxContext } from './Context';
import { BoxVariant, Level } from './types';

interface Props {
  variant?: BoxVariant;
  level?: Level;
}

export const BoxReset: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
  variant = 'background',
  level = 0,
  children,
}) => (
  <BoxContext.Provider value={{ variant, level, isGrid: false }}>{children}</BoxContext.Provider>
);
